<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  ">
    <p-dialog [(visible)]="displaypatientRestoreDialog"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '30vw' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <p-header>
            <h3 class="mb-0 mt-0">Patient Restore</h3>
        </p-header>

        <div class="">
            <div class="p-fluid formgrid grid" style="text-align: center">
                <div class="field col-12 md:col-12">
                    <form [formGroup]="archiverestoreForm">
                        <fieldset legend="Restore By:"
                                  class="pt-2 pb-2"
                                  style="border-color: #ffffff !important">
                            <p-radioButton name="restorebyAll"
                                           value="all"
                                           label="ALL  "
                                           class="mr-6"
                                           formControlName="restorebyAll"
                                           inputId="rbRestoreAll"
                                           (onClick)="ShowhideRestoraion('All')"></p-radioButton>

                            <p-radioButton name="restorebyAll"
                                           value="dateRange"
                                           label="Date Range"
                                           formControlName="restorebyAll"
                                           inputId="rbRestoreDateRange"
                                           (onClick)="ShowhideRestoraion('daterange')"></p-radioButton>
                        </fieldset>
                    </form>
                </div>

                <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange == true">
                    <span class="p-float-label">
                        <p-calendar [(ngModel)]="startdate"
                                    [yearNavigator]="true"
                                    yearRange="{{ yearRangeForDatePicker }}"
                                    [readonlyInput]="true"
                                    showButtonBar="true"
                                    [appendTo]="'body'"
                                    (ngModelChange)="checkSearchButtonState()"></p-calendar>
                        <label for="float-input">From</label>
                    </span>
                </div>
                <div class="field col-12 md:col-6" *ngIf="showrestoreDaterange == true">
                    <span class="p-float-label">
                        <p-calendar [(ngModel)]="enddate"
                                    [yearNavigator]="true"
                                    yearRange="{{ yearRangeForDatePicker }}"
                                    [readonlyInput]="true"
                                    showButtonBar="true"
                                    [appendTo]="'body'"
                                    (ngModelChange)="checkSearchButtonState()"></p-calendar>
                        <label for="float-input">To</label>
                    </span>
                </div>
            </div>
        </div>

        <div style="display: flex; justify-content: center"
             class="col-12 pt-2 pb-0">
            <div class="pr-4">
                <button pButton
                        type="button"
                        icon="pi pi-check"
                        label="Restore"
                        (click)="restoreconfirmation($event)"
                        class="p-button-plain"
                        [disabled]="restorehButtonDisabled"></button>
            </div>
            <div>
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        (click)="goBack('displayDialog')"
                        label="Cancel"
                        class="p-button-plain GreyButton"></button>
            </div>
        </div>
    </p-dialog>

    <p-dialog header="Confirmation!"
              [(visible)]="patientRestorteConfirmatiomDialog"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '400px' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <div class="restore-card">
            <div class="restore-content">
                <!-- Centered image -->
                <img src="../../../../assets/imagesNew/restore2.png"
                     alt="Restore Image"
                     class="restore-image" />

                <!-- Centered texts -->
                <h2>Restore Data?</h2>
                <p>Are you sure you want to restore tonight?</p>
                <p>This Action Cannot Be Undone!</p>
            </div>
        </div>

        <!-- Centered footer buttons -->
        <p-footer class="restore-footer">
            <button pButton
                    type="button"
                    icon="pi pi-check"
                    label="Restore"
                    (click)="restoreconfirmation2('ok')"
                    class="p-button-plain"></button>

            <button pButton
                    type="button"
                    icon="pi pi-times-circle"
                    label="Cancel"
                    (click)="goBack('Confirmation1')"
                    class="p-button-plain"
                    style="margin-left: 12px;"></button>
        </p-footer>
    </p-dialog>

    <p-dialog header="Restoration Created!"
              [(visible)]="patientRestortedSuccessMessage"
              [draggable]="true"
              [modal]="true"
              positionType="absolute"
              [style]="{ width: '400px' }"
              [baseZIndex]="10000"
              [maximizable]="true">
        <div class="restore-card">
            <div class="restore-content">
                <!-- Centered image -->
                <img src="../../../../assets/imagesNew/restore1.png"
                     alt="Restoration Image"
                     class="restore-image" />

                <!-- Centered text -->
                <p>Restoration Queued For Nightly Process.</p>
            </div>
        </div>

        <!-- Centered footer button -->
        <p-footer class="restore-footer">
            <button pButton
                    type="button"
                    icon="pi pi-times-circle"
                    (click)="goBack('Confirmation2')"
                    label="Done"
                    class="p-button-plain"></button>
        </p-footer>
    </p-dialog>

</div>
